module.exports = "/assets/dist/images/Android.png?83fb28a036e61f9042cdb7ee7955b981";